import React, { useEffect, useState } from "react";
import { PRIMARY_COLOR } from "../../assets/style/colors";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { calender_icon } from "../../assets/img";
import { URLS } from "../../Services/Constant";
import { get, post } from "../../Services/ApiHandler";
import { Toast } from "../../Component/Toast";
import DateRange2 from "../../Component/DateRange/DateRange2";
import useStore from "../../LocalStore/useStore";
import CustomScroll from "../../Component/CustomScroll";
import SubmitButton from "../../Component/SubmitButton";

const MyReport = () => {
  const navigate = useNavigate();

  const { kv, set } = useStore();

  const DEFAULT_LOT_OPTIONS = [
    { value: "Dear", label: "Dear" },
    { value: "Kerala", label: "Kerala" },
  ];

  const DEFAULT_TIME_OPTIONS_DEAR = [
    { value: "1 PM", label: "1 PM", game_id: null },
    { value: "6 PM", label: "6 PM", game_id: null },
    { value: "8 PM", label: "8 PM", game_id: null },
  ];

  const DEFAULT_TIME_OPTIONS_KERALA = [
    { value: "3 PM", label: "3 PM", game_id: null },
  ];

  // ----------------------- STATES -----------------------
  const [purchaseDate, setPurchaseDate] = useState(new Date());
  const [winDate, setWinDate] = useState(new Date());

  const [purchaseLotName, setPurchaseLotName] = useState(null);
  const [winLotName, setWinLotName] = useState(null);

  const [time, setTime] = useState(null);
  const [winTime, setWinTime] = useState(null);

  const [lotOptions, setLotOptions] = useState(
    kv.lotOptions || DEFAULT_LOT_OPTIONS,
  );
  const [winLotOptions, setWinLotOptions] = useState(
    kv.lotOptions || DEFAULT_LOT_OPTIONS,
  );

  const [timeOptions, setTimeOptions] = useState([]);
  const [winTimeOptions, setWinTimeOptions] = useState([]);
  const [purchaseTimeMenuOpen, setPurchaseTimeMenuOpen] = useState(false);
  const [winTimeMenuOpen, setWinTimeMenuOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [purchaseSlotId, setPurchaseSlotId] = useState(null);
  const [winSlotId, setWinSlotId] = useState(null);
  const [selectedLotData, setSelectedLotData] = useState([]);

  useEffect(() => {
    if (!purchaseLotName) {
      setTimeOptions(
        purchaseLotName?.value === "Kerala"
          ? DEFAULT_TIME_OPTIONS_KERALA
          : DEFAULT_TIME_OPTIONS_DEAR,
      );
    }
    if (!winLotName) {
      setWinTimeOptions(
        winLotName?.value === "Kerala"
          ? DEFAULT_TIME_OPTIONS_KERALA
          : DEFAULT_TIME_OPTIONS_DEAR,
      );
    }
  }, [winLotName, purchaseLotName]);

  useEffect(() => {
    setPurchaseLotName(null);
    setTime(null);
    setPurchaseSlotId(null);
  }, [purchaseDate]);

  useEffect(() => {
    setWinLotName(null);
    setWinTime(null);
    setWinSlotId(null);
  }, [winDate]); // -sddde

  // ----------------------- FETCH LOT LIST -----------------------
  const getLotList = async (date, isWinning) => {
    try {
      // // console.log("datess", date);

      if (!date) return;

      // Ensure date is a valid Date object, handle string dates
      let dateObj = date;
      if (typeof date === "string") {
        dateObj = new Date(date);
      }
      if (!(dateObj instanceof Date) || isNaN(dateObj.getTime())) return;

      const status = [1, 2, 3, 4, 5];
      const formattedDate = dateObj.toISOString().split("T")[0];
      const queryString = status.map((s) => `status[]=${s}`).join("&");
      // // console.log("datesszz", date);
      const res = await get(
        `${URLS.REPORTFILTER}?date=${formattedDate}&${queryString}`,
      );
      const list = res?.data;

      if (!Array.isArray(list)) return;
      // // console.log("selectedLotData list", list);

      setSelectedLotData(list);

      let formatted = [];

      const lowerList = list.map((x) => x.name.toLowerCase());

      if (lowerList.some((x) => x.startsWith("dear")))
        formatted.push({ value: "Dear", label: "Dear" });

      if (lowerList.includes("kerala"))
        formatted.push({ value: "Kerala", label: "Kerala" });

      if (isWinning) setWinLotOptions(formatted);
      else setLotOptions(formatted);
      set("lotOptions", formatted);
    } catch (err) {
      // // console.log("Lot Error:", err);
    }
  };

  // ---------------------- FETCH TIME LIST ----------------------
  const getTimeList = async (lot, isWinning) => {
    console.log(lot,selectedLotData)
    if (!lot || !selectedLotData) return;
    // // console.log("selectedLotData", selectedLotData);

    try {
      const lowerLot = lot.value.toLowerCase();

      const filtered = selectedLotData
        .filter((item) => {
          const name = item.name.toLowerCase();
          if (lowerLot === "kerala") return name.includes("kerala");
          if (lowerLot === "dear") return name.startsWith("dear");
          return false;
        })
        .map((item) => ({
          value: item.lot_time,
          label: item.lot_time,
          id: item.id,
        }));

      if (isWinning) setWinTimeOptions(filtered);
      else setTimeOptions(filtered);
      set("lotTimeOptions", filtered);
    } catch (err) {
      // // console.log("Time Error:", err);
    }
  };

  // ---------------------- EFFECTS ----------------------

  // Purchase LOT list
  useEffect(() => {
    // // console.log("purchaseDate", purchaseDate);

    getLotList(purchaseDate, false);
  }, [purchaseDate]);

  // Winning LOT list
  useEffect(() => {
    getLotList(winDate, true);
  }, [winDate]);

  // Purchase TIME list
  useEffect(() => {
    getTimeList(purchaseLotName, false);
  }, [purchaseLotName, selectedLotData]);

  // Winning TIME list
  useEffect(() => {
    getTimeList(winLotName, true);
  }, [winLotName, selectedLotData]);

  const handleReport = async (id, isWinning) => {
    if (isWinning) {
      if (!winLotName || !winTime) return;
    } else {
      if (!purchaseLotName || !time) return;
    }
    if (isWinning) {
      setLoading1(true);
    } else {
      setLoading(true);
    }

    const reportName = isWinning ? "winning" : "purchase";
    const res = await get(
      `${URLS.REPORTLIST}/${reportName}?game_slot_id[]=${id}`,
    );
    // // console.log("res report", res);
    // if (res?.status === "success") {
    //   Toast("No records found!");
    //   setLoading1(false);
    //   setLoading(false);
    //   return; // ❌ STOP here — do not navigate
    // }

    if (res?.status === "success") {
      if (isWinning) {
        setLoading1(false);
      } else {
        setLoading(false);
      }
      if (isWinning) {
        navigate("/winning-report", {
          state: { listData: res, slotId: id, reportName: reportName },
        });
      } else {
        navigate("/purchase-report", {
          state: { listData: res, slotId: id, reportName: reportName },
        });
      }
    } else {
      setLoading1(false);
      setLoading(false);
    }
  };

  // ----------------------- CUSTOM SELECT STYLES -----------------------
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderRadius: 8,
      border: `1px solid ${state.isFocused || state.hasValue ? PRIMARY_COLOR : `${PRIMARY_COLOR}`}`,
      boxShadow: state.isFocused ? "transparent" : "0 0 0 1px #dffffd66",
      "&:hover": {
        border: `1px solid ${PRIMARY_COLOR}`,
      },
      backgroundColor: "#F0EDE6",
      minHeight: 51,
      padding: "3px 10px",
      fontFamily: state.isSelected ? "f3" : "f2",
      color: "#000",
    }),

    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
      backgroundColor: "#F0EDE6",
      borderRadius: 8,
    }),

    menuList: (provided) => ({
      ...provided,
      backgroundColor: "#F0EDE6",
      borderRadius: 8,
    }),

    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "transparent"
        : state.isFocused
          ? "transparent"
          : "transparent",
      color: state.isSelected ? "#00211fff" : PRIMARY_COLOR,
      cursor: "pointer",
      ":active": {
        backgroundColor: `${PRIMARY_COLOR}33`,
      },
    }),

    singleValue: (provided) => ({
      ...provided,
      color: PRIMARY_COLOR,
    }),

    indicatorSeparator: () => ({
      display: "none",
    }),

    dropdownIndicator: (provided) => ({
      ...provided,
      color: PRIMARY_COLOR,
      "&:hover": {
        color: PRIMARY_COLOR,
      },
    }),
  };

  const customStyles2 = customStyles;
  const customStyles3 = customStyles;

  // ----------------------- UI -----------------------
  return (
    <div className="dashRightView-foots" >
      <CustomScroll>
        <div className=" containers_list container_overalls pb-5"  style={{
        minHeight: purchaseTimeMenuOpen || winTimeMenuOpen ? '120vh' : '95vh',
      }}>
          <p className="my-2 f4">PURCHASE REPORT</p>

          {/* Purchase Date */}
          <div className="form-group text-start my-3">
            {/* <div className="d-flex mt-3 calender-input1">
          <img
            src={calender_icon}
            alt="calendar"
            className="calender-icon me-2"
            onClick={() => document.getElementById("purchaseDatePicker").focus()}
          />
          <DatePicker
            id="purchaseDatePicker"
            selected={purchaseDate}
            onChange={setPurchaseDate}
            dateFormat="dd-MM-yyyy"
            className="date-input w-100"
            menuPortalTarget={document.body}
            maxDate={new Date()}
            onFocus={(e) => (e.target.readOnly = true)}

          />
        </div> */}

            <DateRange2
              selectedDate={purchaseDate}
              setSelectedDate={setPurchaseDate}
            />
          </div>

          {/* Purchase Lot */}
          <div className="form-group text-start my-3">
            <p style={{ fontWeight: 600 }} className="mb-1 f3 primary">
              Lot Name
            </p>
            <Select
              options={lotOptions}
              value={purchaseLotName}
              onChange={(selected) => {
                setPurchaseLotName(selected);
                setTime(null);
                setPurchaseSlotId(null);
              }}
              placeholder="Select Lot"
              styles={customStyles}
              isSearchable={false}
              menuPortalTarget={document.body}
              noOptionsMessage={() => ""}
            />
          </div>

          {/* Purchase Time */}
          <div className="form-group text-start my-3">
            <p style={{ fontWeight: 600 }} className="mb-1 f3 primary">
              Time
            </p>
            <Select
              options={timeOptions}
              value={time}
              onChange={(selected) => {
                setTime(selected);
                setPurchaseSlotId(selected.id); // ← 🔥 GET ID HERE
                // // console.log("Selected Time ID:", selected.id);
                // // console.log("Full object:", selected.full);
              }}
              placeholder="Select Time"
              styles={customStyles2}
              isSearchable={false}
              isDisabled={!purchaseLotName}
              menuPortalTarget={document.body}
              noOptionsMessage={() => ""}
            />
          </div>

          {/* <button
            onClick={() => handleReport(purchaseSlotId, false)}
            className="add-button f3 black my-3"
            style={{
              opacity: !loading ? 1 : 0.6,
              cursor: !loading ? "pointer" : "not-allowed",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
              minHeight: 48,
              backgroundColor:
                !purchaseLotName || !time ? "#e8b59b" : PRIMARY_COLOR,
            }}
          >
            {loading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                  style={{ color: "black", padding: 8 }}
                ></span>
              </>
            ) : (
              <span>Get Purchase Report</span>
            )}
          </button> */}

          <SubmitButton
            onClick={() => handleReport(purchaseSlotId, false)}
            title="Get Purchase Report"
            disabled={!purchaseLotName || !time || loading}
            isFormValid={!purchaseLotName || !time}
            loading={loading}
          />

          <p className="my-3 f4">WINNING REPORT</p>

          {/* Winning Date */}
          <div className="form-group text-start my-3">
            {/* <p style={{ fontWeight: 600 }} className="mb-1 f1 primary">Date</p>
        <div className="d-flex ac-jb input-box">
          <img
            src={calender_icon}
            alt="calendar"
            className="calender-icon me-2"
            onClick={() => document.getElementById("winDatePicker").focus()}
          />
          <DatePicker
            id="winDatePicker"
            selected={winDate}
            onChange={setWinDate}
            dateFormat="dd-MM-yyyy"
            className="date-input w-100"
            menuPortalTarget={document.body}
            maxDate={new Date()}
            onFocus={(e) => (e.target.readOnly = true)}
          />

        </div> */}
            <DateRange2 selectedDate={winDate} setSelectedDate={setWinDate} />
          </div>

          {/* Winning Lot */}
          <div className="form-group text-start my-3">
            <p style={{ fontWeight: 600 }} className="mb-1 f3 primary">
              Lot Name
            </p>
            <Select
              options={winLotOptions}
              value={winLotName}
              onChange={(selected) => {
                setWinLotName(selected);
                setWinTime(null);
                setWinSlotId(null);
              }}
              placeholder="Select Lot"
              styles={customStyles}
              isSearchable={false}
              noOptionsMessage={() => ""}
              menuPortalTarget={document.body}
            />
          </div>

          {/* Winning Time */}
          <div className="form-group text-start my-3">
            <p style={{ fontWeight: 600 }} className="mb-1 f3 primary">
              Time
            </p>
            <Select
              options={winTimeOptions}
              value={winTime}
              onChange={(selected) => {
                setWinTime(selected);
                setWinSlotId(selected.id);
              }}
              placeholder="Select Time"
              styles={customStyles3}
              isSearchable={false}
              isDisabled={!winLotName}
              noOptionsMessage={() => ""}
              menuPortalTarget={document.body}
               onMenuOpen={() => setWinTimeMenuOpen(true)}
              onMenuClose={() => setWinTimeMenuOpen(false)}
            />
          </div>

          {/* <button
            onClick={() => handleReport(winSlotId, true)}
            className="add-button f3 black my-3"
            style={{
              opacity: !loading1 ? 1 : 0.6,
              cursor: !loading1 ? "pointer" : "not-allowed",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
              minHeight: 48,
              backgroundColor:
                !winLotName || !winTime ? "#e8b59b" : PRIMARY_COLOR,
            }}
          >
            {loading1 ? (
              <>
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                  style={{ color: "black", padding: 8 }}
                ></span>
              </>
            ) : (
              <span>Get Winning Report</span>
            )}
          </button> */}
          <SubmitButton
            onClick={() => handleReport(winSlotId, true)}
            title="Get Winning Report"
            disabled={!winLotName || !winTime || loading1}
            isFormValid={!winLotName || !winTime}
            loading={loading1}
          />
        </div>
      </CustomScroll>
    </div>
  );
};

export default MyReport;
